export function normalizeCypressTestId(testId: string): string {
    return testId.replaceAll(" ", "-").toLowerCase();
}
